// extracted by mini-css-extract-plugin
export var icon = "SocialMedia-module--icon--47b1e";
export var platform = "SocialMedia-module--platform--d8570";
export var socialMedia = "SocialMedia-module--social-media--7820c";